<template>
  <h1>Welcome to Mango</h1>
</template>

<script>
export default {
  name: "Dashboard"
};
</script>
